import { Form, message } from "antd";
import { AiProfileForm } from "./components/AiProfileForm";
import { useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAiProfile, AiProfileInput } from "@/lib/api/resources/agents";

export default function AiProfileCreate() {
  const [form] = Form.useForm<any>();
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  const fromSearch = location.state?.fromSearch || "";

  const mutation = useMutation({
    mutationFn: (values: AiProfileInput) => createAiProfile(values),
    onSuccess: () => {
      message.success("AI Profile created successfully");
      queryClient.invalidateQueries({ queryKey: ["ai_profiles"] });
      navigate(`/ai-profiles${fromSearch}`);
    },
    onError: () => {
      message.error("Failed to create profile");
    },
  });

  const onFinish = (payload: AiProfileInput) => {
    mutation.mutate(payload);
  };

  return (
    <div className="max-w-4xl mx-auto py-2 pb-12">
      <div className="mb-8 pl-1">
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
          Create AI Provider Profile
        </h1>
        <p className="text-gray-500 mt-2 text-sm max-w-2xl">
          Configure a centralized AI provider and model connection that can be
          reused across multiple Agents and Benchmarks.
        </p>
      </div>
      <AiProfileForm
        form={form}
        onFinish={onFinish}
        isSubmitting={mutation.isPending}
      />
    </div>
  );
}
